// src/v3/transactions/unavailable-invoice.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var UnavailableInvoiceIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "UnavailableInvoiceIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M2.25 12C2.25 17.3762 6.62383 21.75 12 21.75C17.3762 21.75 21.75 17.3762 21.75 12C21.75 6.62383 17.3762 2.25 12 2.25C6.62383 2.25 2.25 6.62383 2.25 12ZM3.76869 12C3.76869 7.46418 7.46418 3.76869 12 3.76869C16.5358 3.76869 20.2313 7.46418 20.2313 12C20.2313 16.5358 16.5358 20.2313 12 20.2313C7.46418 20.2313 3.76869 16.5358 3.76869 12ZM8.96263 12.7594H15.0374C15.4525 12.7594 15.7967 12.4151 15.7967 12C15.7967 11.5849 15.4525 11.2407 15.0374 11.2407H8.96263C8.54752 11.2407 8.20328 11.5849 8.20328 12C8.20328 12.4151 8.54752 12.7594 8.96263 12.7594Z"
  }
) });

export {
  UnavailableInvoiceIcon
};
